import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "simpleInputContainer" }
const _hoisted_2 = { class: "simpleInputLabel" }
const _hoisted_3 = ["title"]
const _hoisted_4 = ["readonly"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "simpleInputBottom" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoSign = _resolveComponent("InfoSign")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createTextVNode(_toDisplayString(_ctx.description) + " ", 1),
      (_ctx.tooltipDescription !== '')
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            title: _ctx.tooltipDescription
          }, [
            _createVNode(_component_InfoSign)
          ], 8, _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "text",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.localInputValue) = $event)),
      readonly: _ctx.readonly,
      class: "simpleInputInput"
    }, null, 8, _hoisted_4), [
      [_vModelText, _ctx.localInputValue]
    ]),
    _hoisted_5
  ]))
}